<template>
    <div class="lms__user_account">
        <div class="lms__user_account_header">
            <view-actions
                :title="`My profile`"
                :trash-button-active="false"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="lms__user_account_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: $t('lms.user.account.sidebar.personalInfo'), name: 'lms-user-account-personal' },
                            { label: $t('lms.user.account.sidebar.security'), name: 'lms-user-account-security' },
                            { label: 'Activity log', name: 'lms-user-account-activity-log' }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__user_account_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ViewActions from '@/components/default/shared/ViewActions'
import { validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-user-account',
  components: { ComponentSidebar, ViewActions },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  computed: {
    userName () {
      return this.$store.getters.getAuthUserSecondStageTokenDataNameOutput
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccount.scss";
</style>
